<div class="checkin">
    <div class="header">
        <div class="title">
            {{dialogData.title || ''}}
            <span (click)="dialogRef.close()" class="material-icons side-nav-bar-close">clear</span>
        </div>
    </div>
    <div class="body">

        <p class="text-value">
            {{dialogData.message}}
        </p>

    </div>
    <div class="footer">
        <button (click)="dialogRef.close(false)">
            {{(dialogData.cancelButton ? dialogData.cancelButton : ('BACK' | translate)) | uppercase }}
        </button>
        <button (click)="dialogRef.close(true)">
            {{(dialogData.confirmButton ? dialogData.confirmButton : ('CONFIRM' | translate)) | uppercase }}
        </button>
    </div>
</div>